import { PaneNode } from 'pages/code/helpers'
import { CodeDividers, WidgetType, CodeLayout } from '../../common/types/code'

type LayoutOptions = {
  usePreview?: boolean
}

export const panelLayout = ({ usePreview = false }: LayoutOptions): CodeLayout[] => {
  const isPreview = usePreview

  const widgetsDiagramLayout: PaneNode = {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 60
          },
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 40
          }
        ]
      }
    ]
  }

  const widgetsCodeResultLayout: PaneNode = {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code',
            contentType: WidgetType.CODE,
            dividerKey: CodeDividers.CODE_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }

  return [
    {
      id: 1,
      name: 'app.pages.app.topbar.layout.diagram',
      defaultName: 'Result',
      icon: 'diagram',
      widgets: widgetsDiagramLayout as any
    },
    {
      id: 2,
      name: 'app.pages.app.topbar.layout.result',
      defaultName: 'Code+result',
      icon: 'result',
      widgets: widgetsCodeResultLayout as any
    }
  ]
}
